export const environment = {
  production: true,
  gasUrl:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/gases?format=json",
  jobsUrl:"https://simtools.edwardsvacuum.com/pumpCalcWeb/api/gasflow/calculations",
  apiRootURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/',
  userURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/user',
  unitsURL:'https://simtools.edwardsvacuum.com/pumpCalcWeb/api/unitSetting',

  //msal
  redirectUrl:"https://simtools.edwardsvacuum.com/gasflow",
  clientId:'756e3656-80cc-4c5a-ab25-ced6c6fe7d0f',
  authority:'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/',
  preview:false
};
